import React from "react";
import ProductComingSoonLanding from "./ProductComingSoonLanding.jsx";

const HERO_TAGS = ["Advance rates", "Ledger types", "UK businesses"];

const FEATURE_CARDS = [
  {
    title: "Facility & cash-flow visibility",
    description:
      "Model indicative advance rates, fees, and how much working capital you could unlock against outstanding invoices.",
  },
  {
    title: "Match to invoice finance appetite",
    description:
      "Narrow options by sector, facility size, and whether you need disclosed, confidential, or selective invoice finance.",
  },
  {
    title: "Shortlist & apply in one journey",
    description:
      "When live, shortlist facilities and move through sign-up and application without leaving Dynesourcer.",
  },
];

const STEPS = [
  {
    title: "Share business & ledger details",
    body: "Turnover, debtor mix, and invoice patterns help match lenders who fund your type of ledger.",
  },
  {
    title: "Compare facilities & costs",
    body: "See how advances, service fees, and security requirements differ across matched invoice finance products.",
  },
  {
    title: "Shortlist and apply",
    body: "Pick up to five options and continue to online application through Dynesourcer's invoice finance sourcing platform.",
  },
];

const CRITERIA_CHIPS = [
  "Years trading",
  "Annual turnover",
  "Advance rate (%)",
  "Minimum / maximum facility",
  "Debtor concentration limits",
  "Disclosed vs confidential",
  "Selective vs full ledger",
  "Sector & contract type",
  "Personal guarantee / debenture",
];

export default function InvoiceFinanceCalculator() {
  return (
    <ProductComingSoonLanding
      productLabel="Invoice finance"
      heroTitle="Invoice Finance Calculator"
      heroDescription="Unlock cash tied up in invoices with lender-led matching. Compare facilities by sector and ledger type, then source invoice finance products online."
      heroSrc="/invoice_finance.webp"
      primaryCtaText="Source invoice finance now"
      primaryCtaTo="/invoice-finance/invoice-finance-sourcing"
      heroTags={HERO_TAGS}
      introTitle="Invoice finance calculator & sourcing"
      introBody="Dynesourcer helps UK businesses compare invoice discounting and factoring-style facilities with clear costs and eligibility signals. Use invoice finance sourcing today; full calculator modelling is rolling out on this page."
      featureCards={FEATURE_CARDS}
      howItWorksTitle="How invoice finance will work on Dynesourcer"
      howItWorksIntro="Borrowers describe their sales ledger; we match products that fund those invoices under each lender’s rules."
      steps={STEPS}
      criteriaTitle="Typical invoice finance criteria (preview)"
      criteriaIntro="Exact fields will follow lender policy. Below are common filters buyers use when comparing invoice finance."
      criteriaChips={CRITERIA_CHIPS}
      ctaTitle="Ready to source invoice finance?"
      ctaDescription="Enter your business and ledger details to compare matched invoice finance products from UK lenders."
      ctaPrimary={{ to: "/invoice-finance/invoice-finance-sourcing", label: "Source invoice finance now" }}
      ctaSecondary={{ to: "/explore-borrower-journey", label: "Explore borrower journey" }}
    />
  );
}
